import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { TFreezeRes, TFreezeParams } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询冻结记录详情
export function getFreezeDetail(params: TFreezeParams) {
  return request.post<TFreezeRes>(`${baseUrl}/sofipo/v0/user/freezeInformation`, params);
}
